import axios from 'axios'

import { baseURL, HTTP_STATUS } from '../helpers/constants'
import store from '../store'

const request = axios.create({
  baseURL
})

const rutasPublicas = [
  'auth/login'
]

request.pendingRequests = 0 // Nº de llamadas pendientes

// Interceptor para añadir el token a las peticiones
request.interceptors.request.use((config) => {
  request.pendingRequests++

  const token = store.getters['auth/accessToken']
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
}, (error) => {
  decreasePendingRequests()
  return Promise.reject(error)
})

// Interceptor en caso de error token https://thedutchlab.com/blog/using-axios-interceptors-for-refreshing-your-api-token
request.interceptors.response.use((response) => {
  decreasePendingRequests()
  return response
}, async (error) => {
  decreasePendingRequests()

  if (error.response?.status === HTTP_STATUS.UNAUTHORIZED && !rutasPublicas.includes(error.config.url)) {
    store.dispatch('auth/logout')
  }
  return Promise.reject(error)
})

function decreasePendingRequests () {
  request.pendingRequests--

  if (request.pendingRequests === 0) {
    // hide loading
  }
}

export default request
